<template>
  <div style="width:90%">
		<div class="container_body">
      <header class="header_nav">
        <el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
          <el-form-item label="卖方UID" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
          <el-form-item label="卖方用户名" class='tiny' cleartable>
						<el-input style="width: 150px;" v-model="searchInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
          <el-form-item label="卖单状态" class='tiny' cleartable>
            <el-select clearable  v-model="searchInfo.otcSaleStatus" placeholder="请选择状态"
						style="width:150px;">
							<el-option v-for="item in statusList" :key="item.value" :label="item.name"
							:value="item.value"></el-option>
						</el-select>
					</el-form-item>
          <el-form-item label="收款方式" class='tiny' cleartable>
            <el-select clearable  v-model="searchInfo.cardType" placeholder="请选择状态"
						style="width:150px;">
							<!-- <el-option v-for="item in statusList" :key="item.value" :label="item.name"
							:value="item.value"></el-option> -->
              <el-option  label="银行卡" value="1">银行卡</el-option>
              <el-option  label="微信" value="2">微信</el-option>
              <el-option  label="支付宝" value="3">支付宝</el-option>
						</el-select>
					</el-form-item>
          <el-form-item label="时间" class='tiny' cleartable>
            <el-date-picker
              v-model="dateArr"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <template>
              <el-button type="primary" @click="searchRecordsData">查询</el-button>
							<el-button  @click="empty">清空</el-button>
              <el-button  @click="minBuyRecords">买入记录</el-button>
              <el-button type="primary" @click="downloadFile"> 导出 </el-button>
            </template>
          </el-form-item>
        </el-form>
      </header>
      <div style="padding:0 0 10px 20px">
        总额统计：
        <span >{{ totalStatistics }}</span>
      </div>
    </div>
        <el-table :data="recordsData"  style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" 
        element-loading-spinner="el-icon-loading" :header-cell-style="headClass">
          <el-table-column property="userId"  label="卖方UID" align="center"></el-table-column>
          <el-table-column property="username"  label="卖方用户名" width="150" align="center"></el-table-column>
          <el-table-column property="realName"  label="实名信息" align="center"></el-table-column>
          <el-table-column property="integralName"  label="挂卖资产" align="center"></el-table-column>
          <el-table-column property="otcSaleStatus" label="卖单状态" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.otcSaleStatus === 'withdrawing'">挂卖中</span>
              <span v-if="scope.row.otcSaleStatus === 'success'">已完成</span>
              <span v-if="scope.row.otcSaleStatus === 'cancel'">取消</span>
            </template>
          </el-table-column>
          <el-table-column property="otcSaleNumber" label="挂卖数量" align="center">
            <template slot-scope="scope">
              <span>{{ Math.floor(scope.row.otcSaleNumber) }}</span>
            </template>
          </el-table-column>
          <el-table-column property="otcSalePrice" label="单价" align="center"></el-table-column>
          <el-table-column property="otcSaleRestNumber" label="剩余数量" align="center"></el-table-column>
          <el-table-column label="收款信息" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="queryIntegralWithdrawal(scope.row.id)">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="驳回原因" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="viewRecord(scope.row.images,scope.row.remark)">
                查看
              </el-button>
            </template>
          </el-table-column>
          <el-table-column property="createDate" label="创建时间" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column property="serviceCharge" label="手续费" align="center"></el-table-column>
          <el-table-column property="seviceRadio" label="手续费比例" align="center"></el-table-column>
          <el-table-column  label="操作"  fixed="right"  width="150" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.otcSaleRestNumber>0&&scope.row.otcSaleStatus=='withdrawing'" type="text" size="small" @click="buy(scope.row.id,scope.row.otcSaleRestNumber)">买入</el-button>
              <el-button type="text" size="small" @click="viewRecords(scope.row.id)">查看记录</el-button>
			        <el-button v-if="scope.row.otcSaleRestNumber>0&&scope.row.otcSaleStatus=='withdrawing'" type="text" size="small" @click="boh(scope.row.id,scope.row.otcSaleRestNumber)">驳回挂卖</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination  background :current-page="page.pageNum"
            @current-change="pageChangeRecords" layout="total, sizes, prev, pager, next, jumper" :total="recordsTotal"
            @size-change="handleSizeChangeRecords" :page-sizes="[10, 20, 50, 100]">
        </el-pagination>

        <el-dialog style="float:rigin" title="查看收款信息" :closeOnClickModal="false" :visible.sync="dialogDatil"	width="40%">
          <div class="app-container">
            <el-form :inline="true" label-position="left" :model="payment" style="margin: 20px 0px 0px 20px;">
                  <div style="height:50px">
                    <el-form-item label="收款账号类别:">
                      <span v-if="payment.cardType == 1"> 银行卡 </span>
                      <span v-if="payment.cardType == 2"> 支付宝 </span>
                      <span v-if="payment.cardType == 3"> 微信 </span>
                    </el-form-item>
                  </div>
                  <div v-if="payment.cardType == 1">
                    <div style="height:50px">
                      <el-form-item label="持卡人姓名:">
                        <span>{{ payment.cardUserName }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="银行卡号:">
                        <span>{{ payment.cardNo }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="开户银行:">
                        <span>{{ payment.cardBank }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="开户银行支行:">
                        <span>{{ payment.cardSubbranch }}</span>
                      </el-form-item>
                    </div>
                  </div>
                  <div v-if="payment.cardType == 2 || payment.cardType == 3 " >
                    <div style="height:50px">
                      <el-form-item label="账户姓名:">
                        <span>{{ payment.cardUserName }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                       <el-form-item label="账号:">
                        <span>{{ payment.cardNo }}</span>
                      </el-form-item>
                    </div>
                  </div>
                 </el-form> 
          </div>
          <div style="text-align: center;">
            <el-button @click="dialogDatil = false">取 消</el-button>
          </div>
        </el-dialog>

        <!-- 买入对话框 -->
        <el-dialog
        title="买入"
        :visible.sync="dialogVisibleBuy"
        width="450px">
        <el-form :inline="true" class="demo-form-inline" :model="accountInfo" style="margin: 20px 0px 0px 20px;">
          <div style="height:45px">
            <el-form-item label="挂卖方:">
             <span style="color: #303133; font-weight: 500;font-size: 18px;">{{ `${accountInfo.userId}~${accountInfo.username}` }}</span>
            </el-form-item>
          </div>
          <div style="height:45px">
             <el-form-item label="手机号:">
              <span style="color: #303133; font-weight: 500;font-size: 18px;">{{ accountInfo.phone }}</span>
            </el-form-item>
          </div>
          <div style="height:45px">
            <el-form-item label="积分名称:">
              <span>{{ accountInfo.integralName}}(单价：￥<span style="color: rgb(255, 0, 0);">{{accountInfo.otcSalePrice}}</span>)</span>
            </el-form-item>
          </div>
          <div style="height:45px">
            <el-form-item label="挂卖数量:">
                <el-tag type="success">{{ accountInfo.otcSaleNumber }}</el-tag>
            </el-form-item>
          </div>
          <div style="height:45px">
            <el-form-item label="剩余数量:">
              <el-tag type="danger">{{ accountInfo.otcSaleRestNumber }}</el-tag>
            </el-form-item>
          </div>
          <div style="height:45px">
            <el-form-item label="买入数量:">
                <el-input v-model="accountInfo.otcBuyNumber" style="width:100px"></el-input>
            </el-form-item>
          </div>
          <div style="height:45px">
            <el-form-item label="积分总价:">
              <span>￥<span style="color: rgb(255, 0, 0);">{{ (accountInfo.otcSalePrice * accountInfo.otcBuyNumber).toFixed(2) }}</span></span>
            </el-form-item>
          </div>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleBuy = false">取 消</el-button>
            <el-button type="primary" @click="sure">买 入</el-button>
          </div>
        </el-dialog>
		<!-- 驳回对话框 -->
		<el-dialog
		title="驳回"
		:visible.sync="dialogVisibleBoh"
		width="650px">
		<el-form :inline="true" class="demo-form-inline" :model="accountInfo" style="margin: 20px 0px 0px 20px;">
		  <div style="height:45px">
		    <el-form-item label="挂卖方:">
		     <span style="color: #303133; font-weight: 500;font-size: 18px;">{{ `${accountInfo.userId}~${accountInfo.username}` }}</span>
		    </el-form-item>
		  </div>
		  <div style="height:45px">
		     <el-form-item label="手机号:">
		      <span style="color: #303133; font-weight: 500;font-size: 18px;">{{ accountInfo.phone }}</span>
		    </el-form-item>
		  </div>
		  <div style="height:45px">
		    <el-form-item label="积分名称:">
		      <span>{{ accountInfo.integralName}}(单价：￥<span style="color: rgb(255, 0, 0);">{{accountInfo.otcSalePrice}}</span>)</span>
		    </el-form-item>
		  </div>
		  <div style="height:45px">
		    <el-form-item label="挂卖数量:">
		        <el-tag type="success">{{ accountInfo.otcSaleNumber }}</el-tag>
		    </el-form-item>
		  </div>
		  <div style="height:45px">
		    <el-form-item label="剩余数量:">
		      <el-tag type="danger">{{ accountInfo.otcSaleRestNumber }}</el-tag>
		    </el-form-item>
		  </div>
			<div>
				<el-form-item label="驳回说明:">
				  <el-input  type="textarea" v-model="bohremark" style="width: 300px;"></el-input>
				</el-form-item>
			</div>
			<div>
				<el-form-item label="上传附件:">
				<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
					:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="3"
					:on-success="onSuccess1">
					<i class="el-icon-plus"></i>
				</el-upload>
				</el-form-item>
			</div>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisibleBoh = false">取 消</el-button>
		    <el-button type="primary" @click="bohsure">驳 回</el-button>
		  </div>
		</el-dialog>
        <el-dialog
          title="买入记录"
          :visible.sync="dialogVisibleMinRecord"
          width="90%">
          <el-form :inline="true" class="demo-form-inline" :model="searchBuyRecordsInfo" style="margin: 20px 0px 0px 20px;">
              <!-- <el-form-item label="订单ID" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.otcSaleId" placeholder="请输入订单ID"></el-input>
              </el-form-item>
              <el-form-item label="资产名称" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.integralName" placeholder="请输入资产名称"></el-input>
              </el-form-item>
              <el-form-item label="订单状态" class='tiny' cleartable>
                <el-select clearable  v-model="searchBuyRecordsInfo.otcStatus" placeholder="请选择状态"
                style="width:150px;">
                  <el-option v-for="item in statusList1" :key="item.value" :label="item.name"
                  :value="item.value"></el-option>
                </el-select>
              </el-form-item> -->

              <el-form-item label="买方用户ID" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.userId" placeholder="请输入买方用户ID"></el-input>
              </el-form-item>
              <el-form-item label="买方用户名" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.username" placeholder="请输入买方用户名"></el-input>
              </el-form-item>
              <el-form-item label="卖方用户ID" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.saleUserId" placeholder="请输入卖方用户ID"></el-input>
              </el-form-item>
              <el-form-item label="卖方用户名" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.saleUsername" placeholder="请输入卖方用户名"></el-input>
              </el-form-item>
              <el-form-item label="订单状态" class='tiny' cleartable>
                <el-select v-model="searchBuyRecordsInfo.otcStatus" placeholder="请选择" clear>
                  <el-option key="waiting" label="等待付款" value="waiting">等待付款</el-option>
                  <el-option key="success" label="交易成功" value="success">交易成功</el-option>
                  <el-option key="cancel" label="交易取消" value="cancel">交易取消</el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <template>
                  <el-button type="primary" @click="searchBuyRecordsData">查询</el-button>
                  <el-button @click="emptyBuyRecords">清空</el-button>
                </template>
              </el-form-item>
            </el-form>
            <el-table :data="buyRecordsData"  style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" 
            element-loading-spinner="el-icon-loading" :header-cell-style="headClass" height="400">
              <!-- <el-table-column property="userId" fixed label="用户ID" align="center" width="70"></el-table-column>
              <el-table-column property="username" fixed label="用户名" align="center" width="150"></el-table-column> -->
              <el-table-column property="userId"  label="买方用户ID" align="center" width="100"></el-table-column>
              <el-table-column property="username"  label="买方用户名" align="center" width="150"></el-table-column>
              <el-table-column property="saleUserId"  label="卖方用户ID" align="center" width="100"></el-table-column>
              <el-table-column property="saleUsername"  label="卖方用户名" align="center" width="150"></el-table-column>

              <el-table-column property="integralName" label="挂卖资产" align="center" width="100"></el-table-column>
              <el-table-column property="otcSaleId"  label="挂卖订单ID" align="center" width="120"></el-table-column>
              <el-table-column property="otcBuyNumber" label="购买数量" align="center">
                <template slot-scope="scope">
                  <span>{{Math.floor(scope.row.otcBuyNumber)}}</span>
                </template>
              </el-table-column>
              <el-table-column property="payMoney" label="积分总价(￥)" align="center"></el-table-column>
              <el-table-column property="certificate" label="付款凭证" align="center" width="150">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image 
                      fit="scale-down"
                      style="width: 100px; height: 100px"
                      :src="scope.row.certificate" 
                      :preview-src-list="[scope.row.certificate]">
                    </el-image>
                  </div>
                  
                </template>
              </el-table-column>
              <el-table-column property="otcStatus" label="订单状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.otcStatus === 'waiting'">等待付款</span>
                  <span v-if="scope.row.otcStatus === 'success'">交易成功</span>
                  <span v-if="scope.row.otcStatus === 'cancel'">交易取消</span>
                </template>
              </el-table-column>
              <el-table-column property="createDate" label="创建时间" width="160" align="center"></el-table-column>
              <el-table-column property="buyMemo" label="备注信息" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.buyMemo == null ? '暂无' : scope.row.buyMemo }}</span>
                </template>
              </el-table-column>
              <el-table-column  label="操作"  fixed="right"  width="150" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.otcStatus === 'waiting'">
                    <el-button type="text" size="small" @click="uploadProof(scope.row.otcSaleId,scope.row.id)">上传凭证</el-button>
                  </div>
                  <div v-if="scope.row.otcStatus === 'waiting'">
                    <el-button type="text" size="small" @click="open(scope.row.id)">取消交易</el-button>
                  </div>
                  <div v-else>
                    <el-button type="text" size="small">暂无操作</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination  background :current-page="page1.pageNum"
                @current-change="pageChangeBuyRecords" layout="total, sizes, prev, pager, next, jumper" :total="buyRecordsTotal"
                @size-change="handleSizeChangeBuyRecords" :page-sizes="[6, 12, 18, 24]">
            </el-pagination>
            <el-dialog
              width="30%"
              title="付款"
              :visible.sync="innerVisible"
              append-to-body>
              <div>
                <el-form :inline="true" class="demo-form-inline" :model="accountInfo" style="margin: 20px 0px 0px 20px;">
                  <div style="height:50px">
                    <el-form-item label="收款账号类别:">
                      <el-select v-model="accountInfo.cardType" placeholder="请选择" disabled>
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div v-if="accountInfo.cardType == 1">
                    <div style="height:50px">
                      <el-form-item label="持卡人姓名:">
                        <span>{{ accountInfo.cardUserName }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="银行卡号:">
                        <span>{{ accountInfo.cardNo }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="开户银行:">
                        <span>{{ accountInfo.cardBank }}</span>
                      </el-form-item>
                    </div>
                    <div style="height:50px">
                      <el-form-item label="开户银行支行:">
                        <span>{{ accountInfo.cardSubbranch }}</span>
                      </el-form-item>
                    </div>
                  </div>
                  <div v-if="accountInfo.cardType == 2 || accountInfo.cardType == 3 " style="height:50px">
                    <el-form-item label="账户姓名:">
                      <el-input v-model="accountInfo.cardUserName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="账号:">
                      <el-input v-model="accountInfo.cardNo" disabled></el-input>
                    </el-form-item>
                  </div>
                  <div v-if="accountInfo.cardType == 2 || accountInfo.cardType == 3 " style="height:50px">
                    <el-form-item label="收款二维码图片:">
                      <el-image 
                        style="width: 150px; height: 150px"
                        :src="accountInfo.cardImg" 
                        fit="scale-down"
                        :preview-src-list="[accountInfo.cardImg]">
                      </el-image>
                    </el-form-item>
                  </div>
                  <div style="height:120px">
                    <el-form-item label="上传凭证:">
                      <el-upload class="avatar-uploader" :action="httpUrl"
                        :before-upload="beforeAvatarUpload" :on-success="onSuccess" :show-file-list="false">
                        <img style="width: 100px;height: 100px;" v-if="imgUrl" :src="imgUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </div>
                  <div style="height:50px">
                    <el-form-item label="备注:">
                      <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        style="width: 250px;"
                        v-model="uploadInfo.buyMemo">
                      </el-input>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="sureUploadProof">确 认</el-button>
              </div>
          </el-dialog>
        </el-dialog>
        <!-- 查看记录 -->
        <el-dialog
          title="查看记录"
          :visible.sync="dialogVisibleViewRecord"
          width="80%">
          <!-- <el-form :inline="true" class="demo-form-inline" :model="searchBuyRecordsInfo" style="margin: 20px 0px 0px 20px;">
              <el-form-item label="订单ID" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.otcSaleId" placeholder="请输入订单ID"></el-input>
              </el-form-item>
              <el-form-item label="资产名称" class='tiny' cleartable>
                <el-input style="width: 150px;" v-model="searchBuyRecordsInfo.integralName" placeholder="请输入资产名称"></el-input>
              </el-form-item>
              <el-form-item label="订单状态" class='tiny' cleartable>
                <el-select clearable  v-model="searchBuyRecordsInfo.otcStatus" placeholder="请选择状态"
                style="width:150px;">
                  <el-option v-for="item in statusList1" :key="item.value" :label="item.name"
                  :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <template>
                  <el-button type="primary" @click="searchBuyRecordsData">查询</el-button>
                  <el-button @click="emptyBuyRecords">清空</el-button>
                </template>
              </el-form-item>
            </el-form> -->
            <el-table :data="viewRecordsData"  style="width: 100%"  v-loading="loading" element-loading-text="拼命加载中" 
            element-loading-spinner="el-icon-loading" :header-cell-style="headClass" height="400">
              <el-table-column property="userId" label="用户ID" align="center" width="70"></el-table-column>
              <el-table-column property="username" label="用户名" align="center" width="150"></el-table-column>
              <el-table-column property="integralName" label="挂卖资产" align="center"></el-table-column>
              <el-table-column property="otcSaleId" label="挂卖订单ID" align="center" width="120"></el-table-column>
              <el-table-column property="otcBuyNumber" label="购买数量" align="center">
                <template slot-scope="scope">
                  <span>{{Math.floor(scope.row.otcBuyNumber)}}</span>
                </template>
              </el-table-column>
              <el-table-column property="payMoney" label="积分总价(￥)" align="center"></el-table-column>
              <el-table-column property="certificate" label="付款凭证" align="center" width="150">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image 
                      fit="scale-down"
                      style="width: 100px; height: 100px"
                      :src="scope.row.certificate" 
                      :preview-src-list="[scope.row.certificate]">
                    </el-image>
                  </div>
                  
                </template>
              </el-table-column>
              <el-table-column property="otcStatus" label="订单状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.otcStatus === 'waiting'">等待付款</span>
                  <span v-if="scope.row.otcStatus === 'success'">交易成功</span>
                  <span v-if="scope.row.otcStatus === 'cancel'">交易取消</span>
                </template>
              </el-table-column>
              <el-table-column property="createDate" label="创建时间" width="160" align="center"></el-table-column>
              <el-table-column property="buyMemo" label="备注信息" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.buyMemo == null ? '暂无' : scope.row.buyMemo }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination  background :current-page="page2.pageNum"
                @current-change="pageChangeViewRecords" layout="total, sizes, prev, pager, next, jumper" :total="viewRecordsTotal"
                @size-change="handleSizeChangeViewRecords" :page-sizes="[6, 12, 18, 24]">
            </el-pagination>
        </el-dialog>
      <!-- 查看驳回 -->
        <el-dialog style="float:rigin" title="查看驳回原因" :closeOnClickModal="false" :visible.sync="dialogDatilBH"	width="40%">
          <div class="app-container">
            <el-carousel indicator-position="outside" height="550px" v-if="bhImg.length > 0">
              <el-carousel-item v-for="item in bhImg" :key="item" >
                <el-image
                style="width: 100%;height:550px"
                fit="scale-down"
                :src="item"></el-image>
              </el-carousel-item>
            </el-carousel>
            <div v-else style="height: 550px;display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;">
                <span>暂无图片</span>
            </div>
            <div style="margin: 20px;font-size:20px;">
              <span>驳回原因：</span>
              <span v-if="bhInfo != null">{{ bhInfo }}</span>
              <span v-else>无</span>
            </div>
          </div>
          <div style="text-align: center;">
            <el-button @click="dialogDatilBH = false">取 消</el-button>
          </div>
        </el-dialog>
  </div>
</template>
<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('otc');
export default {
  data() {
    return {
		
      searchInfo: {},
      recordsData: [],
      deadline: Date.now() + 1000 * 60 * 60 * 8,
      syNum: '',
      dialogDatilBH: false,
      statusList: [
        {
          value: 'withdrawing',
          name: '挂卖中'
        },
        {
          value: 'success',
          name: '已成功'
        },
        {
          value: 'cancel',
          name: '已取消'
        }
      ],
      statusList1: [
        {
          value: 'waiting',
          name: '等待付款'
        },
        {
          value: 'success',
          name: '交易成功'
        },
        {
          value: 'cancel',
          name: '交易取消'
        }
      ],
      recordsID: '',
      recordsTotal: 0,
      buyRecordsTotal: 0,
      viewRecordsTotal: 0,
      dateArr: [],
	    bohremark:'',
      page: {
					pageNum: 1,
					pageSize: 10
			},
      page1: {
					pageNum: 1,
					pageSize: 6
			},
      page2: {
					pageNum: 1,
					pageSize: 6
			},
      loading: false,
      dialogVisibleBuy: false, // 买入对话框
	    dialogVisibleBoh:false,
      dialogVisibleMinRecord: false, // 我的记录对话框
      innerVisible: false, // 
      dialogVisibleViewRecord: false, //
      accountInfo: {}, //账户信息
      buyRecordsData: [],
      searchBuyRecordsInfo: {},
      options: [{
          value: 1,
          label: '银行卡'
        }, {
          value: 2,
          label: '支付宝'
        }, {
          value: 3,
          label: '微信'
        }],
        value: '',
        httpUrl: urls,
        imgUrl: '',
        otcSaleId: '',
        uploadInfo: {},
        maxNum: '',
        id: '',
        viewRecordsData:[],
        dialogDatil:false,
        goodsImages:[],
        dialogImageUrl:'',
        fileList:[],
        payment:{}, //收款信息
        bhInfo: '',
        bhImg: [],
        totalStatistics:0, //总额统计
    }
  },
  watch: {
    'accountInfo.otcBuyNumber': {
      handler(newVal) {
        console.log('买入数量',newVal)
        this.accountInfo.otcSaleRestNumber = this.syNum - newVal
      }
    },
    'accountInfo.otcSaleRestNumber': {
      handler(newVal) {
        console.log('剩余数量',newVal)
        if(newVal< 0) {
          this.$message.error('剩余数量不足，请重新输入')
          this.accountInfo.otcBuyNumber = 0
        }
      }, 
    }
  },
  methods: {
    getTotalStatistics(){
       this.$api.getTotalStatistics(this.searchInfo).then(res => {
          if(res.state == 'success'){
            console.log('总额统计信息---',res)
            this.totalStatistics = res.data
          }
        })
          
    },
    handleRemove(file, fileList) {
	  if (file.response) {
	  	this.goodsImages.remove(file.response.message);
	  }
	  	// this.goodsImages.remove(file.url);
	  	this.fileList = this.fileList.filter(item => item.uid !== file.uid)
	  },
	  handlePictureCardPreview(file) {
	  	this.dialogImageUrl = file.url;
	  	this.dialogVisibleImg = true;
	  },
	  onSuccess1(response, file) {
	  	console.log(response)
	  	this.goodsImages.push(response.message)
	  	this.fileList.push({
	  		"url": response.message
	  	})
	  	console.log("asda", this.fileList)
	  },
    pageChangeRecords(val) {
      this.page.pageNum = val
      this.getRecordsList()
    },
    handleSizeChangeRecords(val) {
      this.page.pageSize = val
      this.getRecordsList()
    },
    
    pageChangeBuyRecords(val) {
      this.page1.pageNum = val
      this.getMinBuyList()
    },
    viewRecord(img,val) {
      if(img == null){
        this.bhImg = []
        this.bhInfo = val
        this.dialogDatilBH = true
      }else {
        this.bhImg = img.split(',')
        this.bhInfo = val
        this.dialogDatilBH = true
      }
     console.log(this.bhImg,val)
    },
    pageChangeViewRecords(val) {
      this.page1.pageNum = val
      this.getOtcBuyInfo()
    },
    
    handleSizeChangeBuyRecords(val) {
      this.page1.pageSize = val
      this.getMinBuyList()
    },
    handleSizeChangeViewRecords(val) {
      this.page1.pageSize = val
      this.getOtcBuyInfo()
    },
    queryIntegralWithdrawal(id){ //查看收款信息
				console.log('收款信息id---',id);
				this.dialogDatil = true
				// this.$api.getStoreId(id).then(res=>{
				// 	res.data=JSON.parse(this.$decrypt(res.data)).data
				// 	if(res.state == 'success'){
				// 		this.payment = res.data
				// 	}
        // })
        
        // uploadProof(id,TID) {
        //   this.innerVisible = true
        //   this.id = TID
        //   this.otcSaleId = id
        //   this.uploadInfo = {}
        //   this.imgUrl = ''
        //   this.payment = {}
        //   this.$api.getotcSale(id).then(res => {
        //     this.payment = res.data
        //   })
        // },

          this.$api.getotcSale(id).then(res => {
            this.payment = res.data
          })
          console.log('收款信息---',this.paymen)
			},
    downloadFile() {
      console.log(this.searchInfo); 
      // let data = {
      //     otcStatus: this.searchInfo.otcStatus ? this.searchInfo.otcStatus : "",
			// 		userId: this.searchInfo.userId ? this.searchInfo.userId : "",
			// 		username: this.searchInfo.username ? this.searchInfo.username : "",
			// 	};
			// console.log(data);
				this.$api.exportExcelOtcSaleRecords(this.searchInfo).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
    },
    showloadFile(res) {
      if (!res) {
        return;
      }
      const link = document.createElement("a");
      let blob = new Blob([res], {
        type: "application/vnd.ms-excel",
      });
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "挂卖订单" + ".xls");
      document.body.appendChild(link);
      link.click();
      // URL.revokeObjectURL(link.href); // 释放URL 对象
      document.body.removeChild(link);
    },
    getRecordsList() {
      this.loading = true
      let obj = {
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize
      }
       let data = Object.assign(this.searchInfo,obj)
      this.$api.getOtcSaleList(data).then(res => {
        if(res.state == 'success'){
          this.loading = false
          this.recordsData = res.data.list
          this.recordsTotal = res.data.total
          console.log(this.recordsData)
        }
      })
    },
    headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
		},
    searchRecordsData() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      if(this.dateArr.length>0){
          this.dateArr.forEach((item,index) => {
          this.dateArr.splice(index,1,this.$moment(item).format('YYYY-MM-DD HH:mm:ss'))
        })
        this.searchInfo.startTime = this.dateArr[0]
        this.searchInfo.endTime = this.dateArr[1]
      }
      this.getTotalStatistics();
      this.getRecordsList();
      // let obj = {
      //   pageNum: this.page.pageNum,
      //   pageSize: this.page.pageSize
      // }
      // let data = Object.assign(this.searchInfo,obj)
      // this.$api.getOtcSaleList(data).then(res => {
      //   if(res.state == 'success'){
      //     this.recordsData = res.data.list
      //     this.recordsTotal = res.data.total
      //   }
      // })
    },
    empty() {
      this.searchInfo = {}
      this.dateArr = []
    },
    searchBuyRecordsData() {
      // let obj = {
      //   otcSaleId: this.searchBuyRecordsInfo.otcSaleId,
      //   integralName: this.searchBuyRecordsInfo.integralName,
      //   otcStatus: this.searchBuyRecordsInfo.otcStatus
      // }
      this.page1.pageNum = 1;
      this.getMinBuyList()
    },
    emptyBuyRecords() {
      this.searchBuyRecordsInfo = {}
    },
    // 买入
    buy(id,num) {
      this.otcSaleId = id
      this.maxNum = num
      this.uploadInfo = {}
      this.accountInfo = {}
      this.dialogVisibleBuy = true
      this.$api.getotcSale(id).then(res => {
        this.accountInfo = res.data
        this.syNum = this.accountInfo.otcSaleRestNumber
        this.$set(this.accountInfo, "otcBuyNumber", res.data.otcSaleRestNumber)
      })
    },
	// 驳回
	boh(id,num) {
	  this.otcSaleId = id
	
	  this.accountInfo = {}
	  this.dialogVisibleBoh = true
	  this.$api.getotcSale(id).then(res => {
	    this.accountInfo = res.data
	    
	  })
	},
    uploadProof(id,TID) {
      this.innerVisible = true
      this.id = TID
      this.otcSaleId = id
      this.uploadInfo = {}
      this.imgUrl = ''
      this.accountInfo = {}
      this.$api.getotcSale(id).then(res => {
        this.accountInfo = res.data
      })
    },
    // 上传图片前，筛选
		beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
      //上传凭证
			onSuccess(response, file, fileList) {
				this.imgUrl = response.message;
			},
      // 确定买入
      sure() {
        let data = {
          otcBuyNumber: this.accountInfo.otcBuyNumber,
          otcSaleId: this.otcSaleId
        }
        this.$api.updateOtcBuy(data).then(res => {
          if(res.state == 'success'){
            this.dialogVisibleBuy = false
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getRecordsList()
            this.getMinBuyList()
            // this.dialogVisibleMinRecord = true
          }else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      },
	  bohsure(){
		  if(!this.bohremark){
			  this.$message({
			    type: 'error',
			    message:'请输入驳回原因'
			  });
			  return
		  }
		 this.$api.bohGmai({id:this.otcSaleId,remark:this.bohremark,images:this.goodsImages.join(',')}).then(res=>{
			 if(res.state=='success'){
				this.$message({
				  type: 'success',
				  message: '驳回成功!'
				});
				this.bohremark=''
				this.goodsImages=[]
				this.fileList=[]
				this.dialogVisibleBoh=false
				this.getRecordsList()
			 }else{
				 this.$message({
				   type: 'error',
				   message:res.message
				 });
			 }
		 })
	  },
      getMinBuyList() {

        // let data = Object.assign(this.page1,obj)
        // this.$api.getListByUserId(this.page1).then(res => {
        //   this.buyRecordsData = res.data.list
        //   this.buyRecordsTotal = res.data.total
        // })

        let data = Object.assign(this.searchBuyRecordsInfo,this.page1)
        this.$api.getOtcBuyList(data).then(res => {
          console.log(res.data)
          if(res.state == 'success'){
            this.buyRecordsData = res.data.list
            this.buyRecordsTotal = res.data.total
          }
        })
      },
      // 我的买入记录
      minBuyRecords() {
        this.dialogVisibleMinRecord = true
        this.getMinBuyList()
      },
      // 确认上传凭证
      sureUploadProof() {
        let data = {
          id: this.id,
          certificate:  this.imgUrl
        }
        this.$api.editOtcBuy(data).then(res => {
          if(res.state) {
            this.innerVisible = false
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.getMinBuyList()
          }else {
            this.$message({
              message: res.message,
              type: 'error'
            })
          }
        })
      },
      open(id) {
        this.$confirm('此操作将取消交易, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
          this.$api.cancelOtcBuy(id).then(res => {
            console.log(res)
            if(res.state == 'success'){
               this.$message({
                type: 'success',
                message: res.message
              });
              this.getMinBuyList()
            }else {
              this.$message({
                type: 'error',
                message: res.message
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });          
        });
      },
      getOtcBuyInfo() {
        let obj = {
          otcSaleId: this.viewId
        }
        let data = Object.assign(this.page2,obj)
        this.$api.getOtcBuyList(data).then(res => {
          if(res.state === 'success'){
            this.viewRecordsData = res.data.list
            this.viewRecordsTotal = res.data.total
          }
        })
      },
      // 查看记录
      viewRecords(id) {
        this.dialogVisibleViewRecord = true
        this.viewId = id
        this.getOtcBuyInfo()
      },
  },
  created() {
    this.getRecordsList()
    this.getTotalStatistics()
  }
}
</script>
<style lang="less">
.el-icon-circle-close {
  color: #fff;
}
.el-image-viewer__close {
  top: 10px;
  right: 450px;
}
</style>